import { envSchema, type EnvConfig } from './schemas/env.schema';

function parseEnv(): EnvConfig {
  const result = envSchema.safeParse(import.meta.env);

  if (!result.success) {
    const errors = result.error.issues.map((e) => `  • ${e.path.join('.')}: ${e.message}`).join('\n');
    throw new Error(`\n❌ Variáveis de ambiente inválidas:\n${errors}\n`);
  }

  return result.data;
}

export const env = parseEnv();
